export const mockPieData = [
    {
      "id": "erlang",
      "label": "erlang",
      "value": 427,
      "color": "hsl(90, 70%, 50%)"
    },
    {
      "id": "elixir",
      "label": "elixir",
      "value": 396,
      "color": "hsl(95, 70%, 50%)"
    },
    {
      "id": "hack",
      "label": "hack",
      "value": 228,
      "color": "hsl(64, 70%, 50%)"
    },
    {
      "id": "scala",
      "label": "scala",
      "value": 157,
      "color": "hsl(94, 70%, 50%)"
    },
    {
      "id": "sass",
      "label": "sass",
      "value": 596,
      "color": "hsl(303, 70%, 50%)"
    }
  ]